import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { environment } from '../../../environments/environment';

import { AudioPlayerService } from '../../services/audio-player.service';
import { Game } from '../../_models/model';
import { IGameResults } from '../game-clicker/game-clicker.component';

const levelData = [
  {
    level: 1,
    data: [{ "number": 1, "dx": -1.1, "dy": 1.8, "enable": false }, { "number": 2, "dx": 1.2, "dy": 1.2, "enable": false }, { "number": 3, "dx": 1.8, "dy": 1, "enable": false }, { "number": 4, "dx": 1.1, "dy": 1, "enable": false }, { "number": 5, "dx": 1.2, "dy": 0.1, "enable": false }, { "number": 6, "dx": 0.4, "dy": 1.9, "enable": false }, { "number": 7, "dx": 0, "dy": -2.2, "enable": false }, { "number": 8, "dx": 2, "dy": 0, "enable": false }, { "number": 9, "dx": 0, "dy": 1.2, "enable": false }, { "number": 10, "dx": 0, "dy": 1.1, "enable": false }]
  },
  {
    level: 2,
    data: [{ "number": 1, "dx": 1.4, "dy": 0, "enable": false }, { "number": 2, "dx": 0.5, "dy": 2.4, "enable": false }, { "number": 3, "dx": 0, "dy": 1.5, "enable": false }, { "number": 4, "dx": 1, "dy": 0, "enable": false }, { "number": 5, "dx": -1.4, "dy": 0.5, "enable": false }, { "number": 6, "dx": 2.4, "dy": 2.4, "enable": false }, { "number": 7, "dx": 0, "dy": 3.1, "enable": false }, { "number": 8, "dx": 0.4, "dy": 1.8, "enable": false }, { "number": 9, "dx": 0.7, "dy": 2, "enable": false }, { "number": 10, "dx": 0, "dy": 2.2, "enable": false }]
  },
  {
    level: 3,
    data: [{ "number": 1, "dx": 0.8, "dy": 0.8, "enable": false }, { "number": 2, "dx": -0.9, "dy": 1, "enable": false }, { "number": 3, "dx": 1.15, "dy": -0.1, "enable": false }, { "number": 4, "dx": -1.5, "dy": 0.4, "enable": false }, { "number": 5, "dx": 0, "dy": -1.8, "enable": false }, { "number": 6, "dx": 0.3, "dy": 1.9, "enable": false }, { "number": 7, "dx": -1.3, "dy": 0, "enable": false }, { "number": 8, "dx": 0, "dy": -1.7, "enable": false }, { "number": 9, "dx": -0.3, "dy": 1.7, "enable": false }, { "number": 10, "dx": 1, "dy": 1, "enable": false }]
  },
  {
    level: 4,
    data: [{ "number": 1, "dx": -1.2, "dy": 0.4, "enable": false }, { "number": 2, "dx": 1.2, "dy": 0, "enable": false }, { "number": 3, "dx": -0.7, "dy": 1.7, "enable": false }, { "number": 4, "dx": -0.3, "dy": 2.5, "enable": false }, { "number": 5, "dx": 1.2, "dy": 0, "enable": false }, { "number": 6, "dx": 0, "dy": 1.9, "enable": false }, { "number": 7, "dx": -1.4, "dy": 0, "enable": false }, { "number": 8, "dx": -0.6, "dy": 2.4, "enable": false }, { "number": 9, "dx": 1.3, "dy": 1.3, "enable": false }, { "number": 10, "dx": -0.4, "dy": -2.2, "enable": false }]
  },
  {
    level: 5,
    data: [{ "number": 1, "dx": -0.5, "dy": 2, "enable": false }, { "number": 2, "dx": -1.2, "dy": 0.3, "enable": false }, { "number": 3, "dx": -0.2, "dy": 1.9, "enable": false }, { "number": 4, "dx": 0.2, "dy": 1.5, "enable": false }, { "number": 5, "dx": -1.4, "dy": 0, "enable": false }, { "number": 6, "dx": -0.9, "dy": 0, "enable": false }, { "number": 7, "dx": 0.2, "dy": 1.5, "enable": false }, { "number": 8, "dx": 1.2, "dy": 0, "enable": false }, { "number": 9, "dx": 1.2, "dy": 0, "enable": false }, { "number": 10, "dx": 0, "dy": 1.5, "enable": false }]
  },
  {
    level: 6,
    data: [{ "number": 1, "dx": -0.9, "dy": 2.2, "enable": false }, { "number": 2, "dx": 0.4, "dy": 2.8, "enable": false }, { "number": 3, "dx": -1.7, "dy": 0, "enable": false }, { "number": 4, "dx": 1.5, "dy": 0, "enable": false }, { "number": 5, "dx": 0, "dy": 2.1, "enable": false }, { "number": 6, "dx": 0, "dy": -2.3, "enable": false }, { "number": 7, "dx": 1.9, "dy": 0, "enable": false }, { "number": 8, "dx": 0, "dy": -2.5, "enable": false }, { "number": 9, "dx": -1.6, "dy": 0, "enable": false }, { "number": 10, "dx": -1.8, "dy": 0, "enable": false }]
  },
  {
    level: 7,
    data: [{ "number": 1, "dx": -1.5, "dy": -0.7, "enable": false }, { "number": 2, "dx": -0.4, "dy": 2.1, "enable": false }, { "number": 3, "dx": -0.3, "dy": -2.2, "enable": false }, { "number": 4, "dx": 1.2, "dy": 0.5, "enable": false }, { "number": 5, "dx": 0, "dy": 1.8, "enable": false }, { "number": 6, "dx": -0.4, "dy": 2.1, "enable": false }, { "number": 7, "dx": 0, "dy": 1.7, "enable": false }, { "number": 8, "dx": 1.2, "dy": 1.2, "enable": false }, { "number": 9, "dx": 0, "dy": 2.5, "enable": false }, { "number": 10, "dx": -0.5, "dy": 2, "enable": false }]
  },
  {
    level: 8, data: [{ "number": 1, "dx": 0, "dy": 2.3, "enable": false }, { "number": 2, "dx": -1.3, "dy": 0.3, "enable": false }, { "number": 3, "dx": -1.6, "dy": 0.2, "enable": false }, { "number": 4, "dx": 0, "dy": -2, "enable": false }, { "number": 5, "dx": -1.4, "dy": 0, "enable": false }, { "number": 6, "dx": 0, "dy": 2.2, "enable": false }, { "number": 7, "dx": 1.1, "dy": 1.1, "enable": false }, { "number": 8, "dx": 1.8, "dy": 0, "enable": false }, { "number": 9, "dx": 2.1, "dy": 0, "enable": false }, { "number": 10, "dx": 0, "dy": -1.9, "enable": false }]
  }
];

interface gameData {
  nr: number;
  done: boolean;
  element: SVGGElement;
  visible: boolean;
  hideStyle: {
    transform: string;
  }
  style: {
    top: string;
    left: string;
    transform: string;
    fontSize: string;
  }
  extraStyle: {
    left: string;
    top: string;
    width: string;
    height: string;
    backgroundColor: string;
    transform: string;
    fontSize: string;
    borderColor: string;
    display: string;
    pointerEvents: string;
  }
}

interface IModeSettings {
  speed: number;
  frameSpeed: number;
  visibleTime: number;
  gameDuration: number;
  extraClickerSize: number; // Optional, only for expert mode
}
const ModeSettingsBeginner: IModeSettings = {
  speed: 1800,          // Duration of one broedel to appear in ms
  visibleTime: 4000,     // Time the broedel is visible in ms
  frameSpeed: 100,      // Speed of the game loop in ms
  gameDuration: 90000,   // Total game duration in ms
  extraClickerSize: 75   // Optional, only for expert mode
};
const ModeSettingsExpert: IModeSettings = {
  speed: 1800,
  visibleTime: 1800,
  frameSpeed: 100,
  gameDuration: 60000,
  extraClickerSize: 0
};

@Component({
  selector: 'app-game-clicker-background',
  templateUrl: './game-clicker-background.component.html',
  styleUrls: ['./game-clicker-background.component.less']
})
export class GameClickerBackgroundComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @HostListener('window:resize', ['$event']) onResize(event: Event) {
    this.resize();
  }
  @HostListener('window:keydown.d', ['$event'])
  debugModeToggle(keycode: KeyboardEvent) {
    if (!environment.allowSkip) {
      return;
    }
    this.showEditor = !this.showEditor;
    this.state.enabled = !this.showEditor;
    if (this.state.enabled) {
      this.start();
    }
  }
  @HostListener('window:keydown.c', ['$event'])
  quickEnd(keycode: KeyboardEvent) {
    if (!environment.allowSkip) {
      return;
    }
    this.endGame();
  }
  @Input() game!: Game;
  @Input() replayCounter: number = 0;
  @Input() mode: 'beginner' | 'expert' = 'beginner';
  @Input() set started(value: boolean) {
    if (value) {
      if (!this.state.enabled) {
        this.start();
      }
    }
  }
  debugStyle = {
    top: '',
    bottom: '0',
  }
  showEditor = false;
  svgSource?: string;
  @Output() clicked: EventEmitter<number> = new EventEmitter<number>();
  @Output() completed: EventEmitter<IGameResults> = new EventEmitter<IGameResults>();
  svgImage!: SVGElement;
  gameData: gameData[] = [];

  levelInfo: { number: number, dx: number, dy: number, enable?: boolean }[] = [
    { number: 1, dx: 1, dy: 1 },
    { number: 2, dx: 1, dy: 1 },
    { number: 3, dx: 1, dy: 1 },
    { number: 4, dx: 1, dy: 1 },
    { number: 5, dx: 1, dy: 1 },
    { number: 6, dx: 1, dy: 1 },
    { number: 7, dx: 1, dy: 1 },
    { number: 8, dx: 1, dy: 1 },
    { number: 9, dx: 1, dy: 1 },
    { number: 10, dx: 1, dy: 1 }
  ];
  levelInfoString = JSON.stringify(this.levelInfo)

  modeSettings: IModeSettings = ModeSettingsBeginner;

  // private speed = 1800;
  // testStyle = {
  //   left: '0px',
  //   top: '0px',
  //   width: '100px',
  //   height: '100px',
  //   backgroundColor: 'transparent',
  //   transform: ''
  // }
  // private frameSpeed = 100;
  // private gameDuration = 60000;

  public state = {
    time: 0,          // Total time passed in ms
    enabled: false,   // Is the game currently active
    active: 0,        // The currently active broedel number
    start: 0,         // The start time of the game in ms
    position: 0,      // The current position in the game (0-360 degrees)
    count: 0          // The number of broedels found
  }
  constructor(
    private audioService: AudioPlayerService
  ) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mode) {
      switch (changes.mode.currentValue) {
        case 'beginner':
          this.modeSettings = ModeSettingsBeginner;
          break;
        case 'expert':
          this.modeSettings = ModeSettingsExpert;
          break;
        default:
          this.modeSettings = ModeSettingsBeginner;
      }
    }
    if (changes.replayCounter) {
      if (!changes.replayCounter.isFirstChange()) {
        this.reset();
      }
    }

  }
  ngAfterViewInit(): void {

  }
  ngOnDestroy(): void {
    this.state.enabled = false;
    this.audioService.stopMusic();
  }

  ngOnInit(): void {


    this.svgSource = '/img/games/zoekplaat/zoekplaat-0' + this.game.levelNumber + '.svg';
    if (this.game) {
      const staticData = levelData.find(ld => ld.level === this.game.levelNumber);
      if (staticData) {
        this.levelInfo = staticData.data;
      } else {
        const data = localStorage.getItem('level_' + this.game.id);
        if (data) {
          this.levelInfo = JSON.parse(data);
        }
      }
    }

  }

  private start() {
    this.state.enabled = true;
    this.state.start = new Date().getTime();
    this.state.time = 0;
    this.state.count = 0;
    this.state.position = 0;
    this.state.active = 0;
    requestAnimationFrame(() => { this.loop() })
  }
  private reset() {
    this.gameData.forEach(broedelInfo => {
      broedelInfo.done = false;
      broedelInfo.visible = false;
      broedelInfo.element?.classList.remove('done');
    });
    this.resize();
    this.start();
  }
  private loop() {
    const timePassed = (new Date).getTime() - this.state.time;
    const absTime = (new Date).getTime() - this.state.start;
    if (!this.state.enabled) {
      return;
    }
    this.state.position = Math.min(360, Math.round((absTime / this.modeSettings.gameDuration * 360)));
    if (this.state.active > 0) {
      if (timePassed > this.modeSettings.visibleTime) {
        this.state.time = (new Date).getTime();
        this.doEvents();
      }
    } else {
      if (timePassed > this.modeSettings.speed) {
        this.state.time = (new Date).getTime();
        this.doEvents();
      }
    }
    if (absTime > this.modeSettings.gameDuration) {
      this.state.enabled = false;
      this.endGame();
    }
    if (this.state.enabled) {
      setTimeout(() => {
        requestAnimationFrame(() => this.loop())
      }, this.modeSettings.frameSpeed);
    }
  }
  private doEvents() {
    this.gameData.forEach(broedel => {
      if (!broedel.element) {
        return;
      }
      // Hide
      broedel.element?.classList.remove('visible');
      broedel.element.classList.add('started');
      broedel.visible = false;
      broedel.element.style.transform = broedel.hideStyle.transform;
      broedel.extraStyle.backgroundColor = 'transparent';
      broedel.extraStyle.borderColor = 'transparent';
      broedel.extraStyle.display = 'none';
      broedel.extraStyle.pointerEvents = 'none';
    })
    const availableBroedels = this.gameData.filter(gd => !gd.done);
    // console.log(availableBroedels);
    if (availableBroedels.length > 0) {

      if (this.state.active) {
        this.state.active = 0;
      } else {

        const activeBroedel = availableBroedels[Math.floor(Math.random() * availableBroedels.length)];
        this.state.active = activeBroedel.nr;
        if (activeBroedel.element) {
          activeBroedel.element.classList.add('visible');
          activeBroedel.visible = true;
          activeBroedel.element.style.transform = '';
          // activeBroedel.extraStyle.borderColor = 'red';
          if (this.mode !== 'expert') {
            activeBroedel.extraStyle.display = 'block';
            activeBroedel.extraStyle.pointerEvents = 'all';
          }
        }

      }
    } else {
      this.endGame();

    }


  }

  private resize() {
    this.gameData.forEach(broedelInfo => {
      if (broedelInfo.element) {
        const left = broedelInfo.element.getBoundingClientRect().left - this.svgImage.getBoundingClientRect().left;
        const top = broedelInfo.element.getBoundingClientRect().top - this.svgImage.getBoundingClientRect().top;
        const moveX = broedelInfo.element.getBoundingClientRect().width / 2;
        const moveY = broedelInfo.element.getBoundingClientRect().height / 2;
        broedelInfo.style.left = left + 'px';
        broedelInfo.style.top = top + 'px';
        broedelInfo.style.transform = 'translate(calc(-50% + ' + moveX + 'px), calc(-50% + ' + moveY + 'px))';
        broedelInfo.style.fontSize = Math.max(moveY, moveX) * 4 + 'px';
        const changeData = this.levelInfo.find(d => d.number === broedelInfo.nr);
        if (!changeData) {
          throw Error('change date not found');
        }
        broedelInfo.hideStyle.transform = 'translate(' + (changeData.dx * 2) + '% , ' + (changeData.dy * 2) + '%)';
        broedelInfo.element.style.transform = broedelInfo.hideStyle.transform;
        broedelInfo.extraStyle.left = left + 'px';
        broedelInfo.extraStyle.top = top + 'px';
        broedelInfo.extraStyle.transform = 'translate(calc(-50% + ' + moveX + 'px), calc(-50% + ' + moveY + 'px))';
        broedelInfo.extraStyle.fontSize = Math.max(moveY, moveX) * 4 + 'px';
        broedelInfo.extraStyle.backgroundColor = 'transparent';
        broedelInfo.extraStyle.display = 'none';
        broedelInfo.extraStyle.pointerEvents = 'none';
        // this.testStyle.fontSize = Math.max(moveY, moveX) * 4 + 'px';
        // this.testStyle.transform = 'translate(calc(-50% + ' + moveX + 'px), calc(-50% + ' + moveY + 'px)) scale(1.5)'
        // this.testStyle.transform = 'translate(calc(-50% + ' + moveX + 'px), calc(-50% + ' + moveY + 'px)) scale(1.5)'

      }

    })
  }

  init(svgImage: SVGElement) {
    this.svgImage = svgImage;

    this.gameData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(i => {
      const broedel: gameData = {
        nr: i,
        done: false,
        style: {
          left: '0px',
          top: i * 80 + 'px',
          transform: '',
          fontSize: '8em'
        },
        extraStyle: {
          left: '0px',
          top: i * 80 + 'px',
          width: this.modeSettings.extraClickerSize + 'px',
          height: this.modeSettings.extraClickerSize + 'px',
          backgroundColor: 'transparent',
          transform: '',
          fontSize: '8em',
          borderColor: 'transparent',
          pointerEvents: 'none',
          display: 'none'
        },
        visible: false,
        hideStyle: { transform: '' },
        element: this.svgImage.querySelector('g[data-name="broedel_' + i + '"]') as SVGGElement,

      }
      broedel.element.addEventListener('click', ($event) => this.broedelClick(broedel, $event))
      broedel.element.classList.add('broedel');

      return broedel;


    })

    this.resize();

    if (this.state.enabled) {
      this.start();
    }

  }

  clickExtra($event: MouseEvent, broedelInfo: gameData) {
    if (this.mode === 'expert') {
       return;
    }
    // $event.stopPropagation();
    // $event.preventDefault();
    // broedelInfo.extraStyle.backgroundColor = 'green';
    this.broedelClick(broedelInfo, $event);
  }

  broedelClick(broedelInfo: gameData, $event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();
    this.audioService.playSoundClick();
    broedelInfo.element?.classList.add('done');
    broedelInfo.done = true;
    broedelInfo.extraStyle.display = 'none';
    broedelInfo.extraStyle.pointerEvents = 'none';
    this.state.count = this.gameData.filter(gd => gd.done).length;
  }

  private endGame() {
    this.state.active = 0;
    this.state.enabled = false;
    this.completed.emit({
      completed: true,
      foundBroedels: this.gameData.filter(gd => gd.done).length
    });
  }

  // Debug
  updateLevelInfo() {
    this.resize();
    this.gameData.forEach(broedel => {
      if (!broedel.element) {
        return;
      }
      const changeData = this.levelInfo.find(d => d.number === broedel.nr);
      if (!changeData) {
        throw Error('change date not found');
      }
      // broedel.hideStyle.transform = 'translate(' + changeData.dx + 'em , ' + changeData.dy + 'em)';
      broedel.element.style.transform = broedel.hideStyle.transform;
      broedel.element?.classList.remove('visible');
      broedel.extraStyle.borderColor = 'transparent';

      if (changeData.enable) {
        broedel.element?.classList.add('visible');
        broedel.element.style.transform = ''
        // broedel.extraStyle.borderColor = 'red';
        if (this.mode !== 'expert') {
          broedel.extraStyle.display = 'block';
          broedel.extraStyle.pointerEvents = 'all';
        }
      }
    })
    localStorage.setItem('level_' + this.game.id, JSON.stringify(this.levelInfo));
  }
  move() {
    if (this.debugStyle.top === '0') {
      this.debugStyle.top = 'auto';
      this.debugStyle.bottom = '0'
    } else {
      this.debugStyle.top = '0';
      this.debugStyle.bottom = 'auto'
    }
  }
}
